import {DateTime} from "luxon";
import $ from "cash-dom";

export const countdownComponent = () => {
    const countdownEnd = DateTime.local(2023, 10, 9, 9, 0);

    const $countdownNumbers = [
        $("#countdown-d"),
        $("#countdown-h"),
        $("#countdown-m"),
        $("#countdown-s"),
    ];
    const $countdownSigns = [
        $("#sign-d"),
        $("#sign-h"),
        $("#sign-m"),
        $("#sign-s"),
    ];
    const countTexts = [
        ['Dní', "Dni", "Deň", "Dní"],
        ['Hodín', "Hodiny", "Hodina", "Hodín"],
        ['Minút', "Minúty", "Minúta", "Minút"],
        ['Sekúnd', "Sekundy", "Sekunda", "Sekúnd"],
    ];

    const updateCountdown = () => {
        const countdownData = countdownEnd.diffNow().toFormat('dd hh mm ss').split(" ");

        for (let x = 0; x < $countdownNumbers.length; ++x) {
            const $number = $countdownNumbers[x];
            const $sign = $countdownSigns[x];
            const texts = countTexts[x];
            const value = countdownData[x];

            if ($number.text() === value)
                continue;

            $number.text(value);

            if (value > "04")
                $sign.text() !== texts[0] && $sign.text(texts[0]);
            else if (value > "01")
                $sign.text() !== texts[1] && $sign.text(texts[1]);
            else if (value === "01")
                $sign.text() !== texts[2] && $sign.text(texts[2]);
            else
                $sign.text() !== texts[3] && $sign.text(texts[3]);
        }

        requestAnimationFrame(updateCountdown);
    };

    requestAnimationFrame(updateCountdown);
};
